export default __webpack_public_path__ + "static/media/bar.ea074175.webp";